export function plural(n, one, few, many) {
    const lastTwo = Math.abs(n) % 100
    const lastOne = lastTwo % 10
    if (lastOne === 1 && lastTwo !== 11) return one
    if (lastOne >= 2 && lastOne <= 4 && (lastTwo < 12 || lastTwo > 14)) return few
    return many
}


export function capitalizeFirstLetter(s) {
    return s.charAt(0).toUpperCase() + s.slice(1)
}



export function getNameFromId(id) {
  // Simple seeded PRNG (mulberry32) driven by a hash of the id
  function hashStr(str) {
    let h = 0
    for (let i = 0; i < str.length; i++) {
      h = Math.imul(31, h) + str.charCodeAt(i) | 0
    }
    return h >>> 0
  }

  function mulberry32(seed) {
    let s = seed | 0
    return function () {
      s = s + 0x6D2B79F5 | 0
      let t = Math.imul(s ^ (s >>> 15), 1 | s)
      t = t + Math.imul(t ^ (t >>> 7), 61 | t) ^ t
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
  }

  const rand = mulberry32(hashStr(String(id)))

  const vowels = "aeiou"
  const consonants = "bcdfghjklmnpqrstvwxyz"
  const surnameEndings = ["son", "ić", "ov", "ova", "ski", "ska"]

  function makeWord(minLen, maxLen) {
    const length = Math.floor(rand() * (maxLen - minLen + 1)) + minLen
    let word = ""
    let useConsonant = rand() < 0.5

    for (let i = 0; i < length; i++) {
      if (useConsonant) {
        word += consonants[Math.floor(rand() * consonants.length)]
      } else {
        word += vowels[Math.floor(rand() * vowels.length)]
      }
      useConsonant = !useConsonant
    }

    return word[0].toUpperCase() + word.slice(1)
  }

  function makeSurname() {
    const ending = surnameEndings[Math.floor(rand() * surnameEndings.length)]
    const baseLength = Math.max(3, 8 - ending.length)
    let base = makeWord(baseLength, baseLength + 2)

    if (/[aeiou]$/i.test(base)) {
      base = base.slice(0, -1)
    }

    return base + ending
  }

  const firstName = makeWord(3, 9)
  const lastName = makeSurname()

  return `${firstName} ${lastName}`
}
